import React from "react";
import "./HomePage.css";
import welcomeImage from "../images/first.png";

const HomePage = ({ language }) => {
  const handleCopy = (copy) => {
    let text = "lukarostomking@gmail.com";
    if (copy !== "gmail") text = "+34603141447";
    navigator.clipboard.writeText(text);
  };

  return (
    <div id="home" className="homepage">
      <div className="homepage-text">
        <div>
          <h1>{language.welcomeText}</h1>
          <h4 className="homepage-contact-text">
            <div onClick={() => handleCopy("gmail")}>
              <i className="fa-solid fa-envelope"></i> lukarostomking@gmail.com
            </div>
            <div onClick={() => handleCopy("number")}>
              <i className="fa-solid fa-mobile"></i>
              +34603141447
            </div>
          </h4>
        </div>
      </div>
      <div className="homepage-image">
        <img src={welcomeImage} alt="welcome" />
      </div>
    </div>
  );
};

export default HomePage;
